import styled, { FlattenSimpleInterpolation } from 'styled-components'

import { CssUnit } from '@/types'
import { colors } from '@/styles'

import { ReactComponent as LivLogo } from './logo.svg'

interface Props {
  duration?: number
  circle?: boolean
  borderRadius?: CssUnit
  height?: CssUnit
  width?: CssUnit
  showLogo?: boolean
  inline?: boolean
  top?: CssUnit
  bottom?: CssUnit
  customStyle?: FlattenSimpleInterpolation | undefined
}

const defaultBaseColor = '#eee'
const defaultHighlightColor = colors.grey96

const Wrapper = styled.span<Props>`
  @keyframes skeletonAnimation {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: calc(200px + 100%) 0;
    }
  }

  display: ${props => (props.inline ? 'inline-flex' : 'flex')};
  justify-content: center;
  align-items: center;
  background-color: ${defaultBaseColor};
  background-image: linear-gradient(
    90deg,
    ${defaultBaseColor},
    ${defaultHighlightColor},
    ${defaultBaseColor}
  );
  margin-top: ${props => props.top || 0}px;
  margin-bottom: ${props => props.bottom || 0}px;
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: ${props => (props.circle ? '50%' : `${props.borderRadius}px`)};
  line-height: 1;
  width: 100%;
  animation: skeletonAnimation ${props => props.duration}s ease-in-out infinite;
  ${({ customStyle }) => customStyle};
`

const Skeleton: React.FC<Props> = ({
  duration = 1.2,
  circle = false,
  borderRadius = 4,
  height,
  width,
  showLogo,
  ...rest
}) => {
  return (
    <Wrapper
      circle={circle}
      duration={duration}
      borderRadius={borderRadius}
      style={{ height, width }}
      {...rest}
    >
      &zwnj;
      {showLogo && (
        <LivLogo width={72} height={101} aria-label="liv.rent Logo" />
      )}
    </Wrapper>
  )
}

export default Skeleton
